/**
*
*   Next Intl Middleware
*       - Loads the Locale Middleware
*
**/
import Config from '@/config';
import CustomerAPI from '@/libraries/shopify-customer/class';


export async function ShopifyRefresh({ token , shopId , shopDomain , clientId , clientSecret }){

    console.log('Refreshing Token');

    //Create the Authorization
    const authorization = btoa(`${ clientId }:${ clientSecret }`);

    //Send the Request
    const tokens = await (
        await fetch(`https://shopify.com/authentication/${ shopId }/oauth/token`, {
            method: 'POST',
            headers: {
                'content-type':     'application/x-www-form-urlencoded',
                'Authorization':    `Basic ${ authorization }`
            },
            body: new URLSearchParams({
                grant_type:     'refresh_token',
                client_id:      clientId,
                redirect_uri:   shopDomain + '/account',
                refresh_token:  token.refreshToken
            }).toString()
        })
    ).json();

    //Error
    if( !tokens.access_token )
        throw new Error( JSON.stringify(token) );

    //return
    return {
        ...tokens,
        expires_in:     tokens.expires_in,
        expiresAt:      new Date().setSeconds( new Date().getSeconds() + tokens.expires_in ),
        refreshToken:   tokens.refresh_token,
        authType:       'customer'
    }

}


/**
*
*   Shopify
*       - The SHopify OAuth Provider
*
**/
export function Shopify({
    shopId,
    shopDomain,
    clientId,
    clientSecret
}){
    return {
        id:             'shopify',
        name:           'Shopify',
        type:           'oauth',
        clientId:       clientId,
        clientSecret:   clientSecret,
        authorization:  {
            url: `https://shopify.com/authentication/${ shopId }/oauth/authorize`,
            params: {
                scope:        'openid email customer-account-api:full',
                redirect_uri: shopDomain + '/api/auth/callback/shopify',
            }
        },
        token: {
            async request(context) {

                //Create the Authorization
                const authorization = btoa(`${ clientId }:${ clientSecret }`);

                //Send the Request
                const tokens = await (
                    await fetch(`https://shopify.com/authentication/${ shopId }/oauth/token`, {
                        method: 'POST',
                        headers: {
                            'content-type':     'application/x-www-form-urlencoded',
                            'Authorization':    `Basic ${ authorization }`
                        },
                        body: new URLSearchParams({
                            grant_type:     'authorization_code',
                            client_id:      clientId,
                            redirect_uri:   shopDomain + '/account',
                            code:           context.params.code,
                            code_verifier:  context.checks.code_verifier
                        }).toString()
                    })
                ).json();

                //Error
                if( !tokens.access_token )
                    throw new Error( JSON.stringify(token) );

                //return
                return {
                    tokens: {
                        ...tokens,
                        expires_at: new Date().setSeconds( new Date().getSeconds() + tokens.expires_in ),
                        auth_type:  'customer'
                    }
                }
            }
        },
        idToken: true,
        checks: ['pkce', 'state'],
        async profile(profile , tokens){

            //Get the Customer
            const customer = await CustomerAPI( tokens.access_token ).get()

            return {
                ...profile,
                name: customer.firstName + ' ' + customer.lastName,
                id: profile.sub
            }
        }
    };
}